import { Component } from '@angular/core';

import {
    DataAuthorizationModel,
    SystemComponent,
} from '../insight/config.insight.model';
import { TabType } from '../insight/tabset.model';

enum Step {
    TAB_TYPE,
    WIZARD,
}

@Component({
    selector: '[cmpsInsightExplorerWizard]',
    templateUrl: './wizard.ie.component.html',
})
export class WizardInsightExplorerComponent {
    Step = Step;
    TabType = TabType;
    currentStep: Step;
    selectedTabType: TabType;

    // eslint-disable-next-line accessor-pairs
    set permissions(value: DataAuthorizationModel[]) {
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        const valid =
            // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
            value &&
            value.filter(
                (e) =>
                    (e.componentId === SystemComponent.HUMAN_INSIGHT ||
                        e.componentId ===
                            SystemComponent.PERFORMANCE_INSIGHT) &&
                    e.granted === 1,
            );
        // only two options are available, if there's only permission for one, skip selection
        if (valid && valid.length === 1) {
            this.currentStep = Step.WIZARD;
            this.selectedTabType =
                valid[0].componentId === SystemComponent.HUMAN_INSIGHT
                    ? TabType.HUMAN
                    : TabType.PERFORMANCE;
        }
    }

    constructor() {
        this.currentStep = Step.TAB_TYPE;
    }
}
